enum HistoryStatus {
  PENDING = 'PENDING',
  HELD = 'HELD',
  SCHEDULED = 'SCHEDULED',
  CREATED = 'CREATED',
}

export default HistoryStatus;
